import React from 'react';
import AdditionalStatsContentContainer from '../../shared/components/AdditionalStatsContentContainer';
import StatsElement from '../../../../shared/entities/stats-element/components/StatsElement';
import { StatsElementType } from '../../../../shared/entities/stats-element/enums/StatsElementType';
import { profitabilityStatsElementOptions } from './constants/profitabilityStatsElementOptions';
import AdditionalStatsPage from '../AdditionalStatsPage';

const ProfitableVsUnprofitable: React.FC = () => {
  return (
    <AdditionalStatsPage>
      <AdditionalStatsContentContainer title="IPO Profitability by Year">
        <StatsElement type={StatsElementType.Profitability} options={profitabilityStatsElementOptions} />
      </AdditionalStatsContentContainer>
    </AdditionalStatsPage>
  );
};

export default ProfitableVsUnprofitable;
